import { render, staticRenderFns } from "./RegistroLlamada.vue?vue&type=template&id=a65ba412&scoped=true&"
import script from "./RegistroLlamada.vue?vue&type=script&lang=js&"
export * from "./RegistroLlamada.vue?vue&type=script&lang=js&"
import style0 from "./RegistroLlamada.vue?vue&type=style&index=0&id=a65ba412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ba412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
